export default __webpack_public_path__ + "static/media/loading2.42aaa181.gif";